<template>
    <div class="collapsable generic">
        <a
            class="trigger title-mid"
            :class="showContent? 'active' : ''"
            href="#"
            @click="onKlapperClicked"
        >
            <icon-base
                ref="icon-dropdown"
                type="icon"
                name="dropdown"
                :additional-css-classes="showContent ? 'icon--default icon--transform': 'icon--default icon--rotate-180 icon--transform'"
            />
            <span
                id="title-text"
                class="full-width"
            >{{ title }}</span>
            <span v-if="showEditIcon">
        <icon-base
            v-if="!showContent"
            ref="icon-edit"
            type="icon"
            name="edit"
        />
      </span>
        </a>
        <div
            ref="klapper-content"
            class="klapper-content"
            :style="[showContent ? {height: computedHeight} : {}]"
        >
            <slot/>
        </div>
    </div>
</template>
<script>
import {defineComponent} from "vue";
import IconBase from "@/components/IconBase";
import {trackGAEvent} from "@/utils/TrackingUtil";

export default defineComponent({
    name: "Klapper",
    components: {IconBase},
    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        showEditIcon: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            required: true
        },
        newHeight: {
            type: Boolean,
            default: false
        },
        trackingAction: String
    },
    emits: ['klapperTriggered'],
    data() {
        return {
            showContent: this.isOpen,
            computedHeight: 0,
            recalcualteHeight: this.newHeight,
            observer: {},
        };
    },
    computed: {},
    watch: {
        showContent: function () {
            this.$emit('klapperTriggered', this.showContent);
        }
    },
    mounted() {
        //Der Observer wird benötigt um die Höhe des Klappers neu zu berechnen wenn sich der Inhalt verändert
        const observer = new MutationObserver(this.calculateHeight)
        observer.observe(this.$refs['klapper-content'], {
            childList: true,
            subtree: true
        })
        this.observer = observer;

        this.calculateHeight();
    },
    beforeUnmount() {
        this.observer.disconnect();
    },
    methods: {
        onKlapperClicked: function (event) {
            event.preventDefault();

            this.showContent = !this.showContent;

            let trackingLabel = 'close';
            if (this.showContent) {
                trackingLabel = 'open';
            }
            if (this.trackingAction && this.trackingAction.length > 0) {
                trackGAEvent(this.$store.state.rechnerNameGAEvents, this.trackingAction, trackingLabel);
            }
        },
        //hier wird die Größe des ausgeklappten Elements ermittelt, die für die Animation benötigt wird
        calculateHeight: function () {
            const content = this.$refs['klapper-content'];
            content.style.height = 'auto';
            content.style.position = 'absolute';
            content.style.visibility = 'hidden';
            content.style.display = 'contents';

            const height = getComputedStyle(content).height;
            this.computedHeight = height;

            content.style.position = null;
            content.style.visibility = null;
            content.style.display = null;

            if (this.showContent) {
                content.style.height = height;
            } else {
                content.style.height = null;
            }
        }
    }
})
</script>
<style scoped lang="less">
.full-width {
    width: 100%;
}

.klapper-content {
    height: 0;
    overflow: hidden;
    transition: .5s;
    margin-top: 10px;
}
</style>
